import styled from 'styled-components';
import { media } from 'theme';

export const Article = styled.article`
  background-color: #ffffff;
  ${media.smallAndDown`
    margin-top: 10px;
    max-width: 100%;
  `}
`;

export const CoverImg = styled.img`
  max-width: 100%;
`;

export const MainContent = styled.section`
  padding: 24px;
  ${media.smallAndDown`
    padding: 16px;
  `}
`;

export const ActionBarContainer = styled.div`
  margin-top: 34px;
  display: block;

  ${media.smallAndDown`
    display: none;
  `}
`;

export const CategoriesWrapper = styled.div`
  color: ${props => props.theme.colors.seedlyBlue};
  text-transform: uppercase;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  margin-top: 10px;

  > * {
    padding-right: 8px;
  }

  > *::after {
    padding-left: 8px;
    content: '|';
  }

  > *:last-of-type::after {
    content: '';
  }
`;

export const Title = styled.h1`
  color: ${props => props.theme.colors.neutral7};
  font-family: Open Sans;
  font-size: 36px;
  line-height: 42px;
  padding: 20px 0;
  font-weight: 700;

  ${media.smallAndDown`
    font-size: 28px;
    line-height: 36px;
`}
`;

export const Body = styled.div<{ page?: number }>`
  padding: ${({ page }) => (page ? '0' : '20px 0')};
  margin: ${({ page }) => (page ? '0' : '16px 0')};
  border-top: ${({ page, theme }) =>
    page ? 'none' : `1px solid ${theme.colors.neutral4}`};
  color: ${props => props.theme.colors.neutral7};
  font-family: Montserrat, Open Sans;
  font-size: 18px;
  line-height: 32px;
  font-weight: 400;
  word-wrap: break-word;

  strong,
  b {
    font-weight: 700;
  }

  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 20px;
    font-weight: bold;
    margin: 20px 0 20px 0;
  }

  h2 {
    margin-top: 60px;
    font-size: 26px;
    ${media.smallAndDown`
      font-size: 22px;
    `}
  }

  h3 {
    font-size: 18px;
    ${media.smallAndDown`
      font-size: 16px;
    `}
  }

  p {
    margin-bottom: 28px;
  }

  a:not([class*='button']) {
    color: ${props => props.theme.colors.seedlyBlue};
    &:hover {
      text-decoration: underline;
    }
  }

  ul,
  ol {
    display: block;
    list-style: disc outside none;
    margin: 1em 0;
    padding: 0 0 0 40px;
  }

  ol {
    list-style-type: decimal;
  }

  li {
    display: list-item;
    list-style: disc;
  }

  hr {
    box-sizing: border-box;
    border: 1px solid ${props => props.theme.colors.neutral4};
  }

  figure {
    width: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  amp-img {
    display: flex;
  }

  .contain img {
    object-fit: contain;
  }

  img {
    clear: both;
    display: block;
    margin-left: auto;
    margin-right: auto;
    height: auto;
    max-width: 100%;
  }

  figcaption {
    text-align: center;
    color: ${props => props.theme.colors.neutral7};
    font-size: 14px;
    padding: 12px 0;

    * {
      color: ${props => props.theme.colors.neutral7};
      font-size: 14px;
      padding: 12px 0;
    }
  }

  .table-wrapper {
    overflow-x: auto;
    margin: 12px 0 28px 0;
    border-radius: 4px;

    table {
      font-size: 14px;
      margin: 0 auto;
    }

    tr {
      width: 100%;
    }

    th {
      font-weight: bold;
      font-size: 14px;
      padding: 4px;
      p {
        font-size: 14px;
      }
    }

    th,
    td {
      border: 2px solid ${props => props.theme.colors.neutral4};
      text-align: center;
      padding: 12px;
      line-height: 22px;

      * {
        font-size: 14px;
      }
    }

    td {
      font-size: 14px;
    }

    tbody {
      tr:nth-child(odd) {
        background-color: ${props => props.theme.colors.neutral2};
      }
    }
  }

  iframe {
    max-width: 100%;
  }

  .fasc-button {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: normal;
    text-decoration: none;
    padding: 8px;
    border-radius: 8px;
    padding: 12px;
    font-weight: bold;
    font-size: 14px;
    font-family: Montserrat, 'Open Sans';
    background-color: ${props => props.theme.colors.seedlyBlue};
    color: white;
  }

  .fixed-height-container {
    position: relative;
    width: 100%;
    height: 150px;
    margin-bottom: 28px;
  }

  blockquote {
    padding: 20px;
    background: ${props => props.theme.colors.neutral2};
    text-transform: italic;
    border-left: 4px solid ${props => props.theme.colors.neutral4};
  }

  blockquote p {
    margin: 0;
  }

  ${media.smallAndDown`
    font-size: 16px;
  `}
`;
